module.exports = __webpack_public_path__ + "static/media/Emblem_jpg.692b85eb.jpg";